import React, { Component } from 'react';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Slider from 'react-slick';
import './styles/customSlickCarousel.css';
import {
  AvailableLanguagesContainer,
  AvailableLanguagesHeading,
  AvailableLanguagesHeadingSpecial,
  AvailableLanguageHeadingIcon,
  AvailableLanguageCardWrapper,
  AvailableLanguageCard,
  AvailableLanguagesImgWrapper,
  AvailableLanguagePara,
} from './styles';
import DsaData from './DsaData.json';
import DsAlgoData from './DsAlgoData.json';
import PackagesData from './PackagesData.json';
import CONFIG from '../../../config';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';

class ProgrammingLanguages extends Component {
  render() {
    const { dsaPage, dsAlgoPage, packages, noMarginBottom } = this.props;
    let pathName = window.location.pathname;

    let PrgLangData;
    if (dsaPage) {
      PrgLangData = DsaData;
    } else if (dsAlgoPage) {
      PrgLangData = DsAlgoData;
    } else if (packages) {
      PrgLangData = PackagesData;
    } else {
      PrgLangData = DsaData;
    }

    const PrevArrow = (props) => {
      const { className, style, onClick } = props;
      return <FaChevronLeft className={className} style={{ ...style }} onClick={onClick} />;
    };

    const NextArrow = (props) => {
      const { className, style, onClick } = props;
      return <FaChevronRight className={className} style={{ ...style }} onClick={onClick} />;
    };

    let settings = {
      dots: true,
      infinite: true,
      speed: 500,
      autoplay: false,
      cssEase: 'linear',
      initialSlide: 0,
      slidesToShow: 6,
      slidesToScroll: 1,
      prevArrow: <PrevArrow />,
      nextArrow: <NextArrow />,
      responsive: [
        {
          breakpoint: 1399,
          settings: {
            slidesToShow: 5,
          },
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 4,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 575,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 359,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    };

    return (
      <AvailableLanguagesContainer noMarginBottom={noMarginBottom}>
        {packages ? (
          <AvailableLanguagesHeading>
            Improve your skills,{' '}
            <span className="d-inline-flex align-items-center no-text-wrap">
              <AvailableLanguagesHeadingSpecial>be remarkable.</AvailableLanguagesHeadingSpecial>
              <AvailableLanguageHeadingIcon src={CONFIG.cloudFront + '/Assets/Pricing/yellow-kick-start-offer.svg'} />
            </span>
          </AvailableLanguagesHeading>
        ) : (
          <AvailableLanguagesHeading>
            Unlock the Power of <AvailableLanguagesHeadingSpecial>DSA in 6</AvailableLanguagesHeadingSpecial> Major Languages!
          </AvailableLanguagesHeading>
        )}
        <Slider {...settings}>
          {PrgLangData.map((data) => {
            let link = packages
              ? `${data.link}/?lb_content=${window.location.hostname + window.location.pathname}&lb_cta=hmp-pkg-icon`
              : `${data.link}/?lb_content=${window.location.hostname + window.location.pathname}&lb_cta=dsa-icon`;
            return (
              <AvailableLanguageCardWrapper key={data.id}>
                <AvailableLanguageCard
                  nonClickable={data.upComing === true}
                  onClick={() => {
                    if (data.upComing !== true) {
                      window.location.href = link;
                    }
                  }}
                  active={pathName === data.link || pathName === `${data.link}/`}
                >
                  <AvailableLanguagesImgWrapper>
                    <img src={CONFIG.cloudFront + data.img} className="img-fluid" alt={data.name} />
                  </AvailableLanguagesImgWrapper>
                  <AvailableLanguagePara active={pathName === data.link || pathName === `${data.link}/`}>{packages ? data.name : data.shortName}</AvailableLanguagePara>
                  {data.upComing === true ? <span className="text-info fs-14">(upcoming)</span> : null}
                </AvailableLanguageCard>
              </AvailableLanguageCardWrapper>
            );
          })}
        </Slider>
      </AvailableLanguagesContainer>
    );
  }
}

export default ProgrammingLanguages;
